// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let PageUITitle = require("../../../components/PageTitle/PageUITitle.bs.js");
let ContentBox__Jsx3 = require("../../../uikit/reason/atoms/ContentBox/ContentBox__Jsx3.bs.js");
let PasswordSettings = require("../../../v5/settings/PasswordSettings.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function PasswordPage(props) {
  return JsxRuntime.jsxs(ContentBox__Jsx3.make, {
    paddingFull: true,
    hasShadow: true,
    children: [
      JsxRuntime.jsx(PageUITitle.make, {
        title: "Password"
      }),
      JsxRuntime.jsx(PasswordSettings.make, {})
    ]
  });
}

let make = PasswordPage;

exports.make = make;
/* PageUITitle Not a pure module */
